import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

const select = (state: RootState) => state.organization.service;

export const servicesSelector = createSelector(
  select,
  (service) => service.items,
);
